import {
  DEPARTURE_FOOTER_COUNTERS_REFRESH_FAILED,
  DEPARTURE_FOOTER_COUNTERS_REFRESH_LOADING,
  DEPARTURE_FOOTER_COUNTERS_REFRESH_SUCCESS,
} from "../types"

const initialState = {
  loading: false,
  error: false,
  message: null,
  counters: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DEPARTURE_FOOTER_COUNTERS_REFRESH_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
        message: null,
        counters: null,
      }
    case DEPARTURE_FOOTER_COUNTERS_REFRESH_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        counters: null,
      }
    case DEPARTURE_FOOTER_COUNTERS_REFRESH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: null,
        counters: action.payload,
      }
    default:
      return state
  }
}
